// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1AX4h","requiredAsterisk":"Info_requiredAsterisk__2xwGL"};